const Strings = {
  NOT_FOUND: {
    SE: '404 sidan kunde inte hittas',
    EN: '404 page not found'
  },
  PAGE_DOES_NOT_EXIST: {
    SE: 'Tyvärr så finns inte sidan som du söker.',
    EN: 'We are sorry but the page you are looking for does not exist.'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/other/NotFound/strings.js